import {extendsAPIServices} from "./APIServices"
import getEnv from "../../helpers/common/getEnv"
import {GET} from "../../constants/HTTPConstants"

const baseAdminAPI = getEnv('baseFbResourceAPI')
const api = extendsAPIServices(baseAdminAPI)

export const _getTotalResults = () => {
    return api.makeAuthRequest({
        method: GET,
        url: '/search-histories/total',
    })
}

export const _getTotalRemainJobs = () => {
    return api.makeAuthRequest({
        method: GET,
        url: '/search-histories/count-jobs',
    })
}

export const _getSearchHistory = (userId) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/users/${userId}/search-history`
    })
}


// WEBPACK FOOTER //
// ./src/services/apis/SearchHistoryServices.js